import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { LocalizedText, closeAlert, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog, IconName } from '@optimus-web/core';
import { useDeleteServicePromotion } from '../queries/useDeleteServicePromotion';

interface DeleteServicePromotionDialogProps {
    promotedService: PromotedServiceAssignment;
    active: boolean;
    onClose: () => void;
}

export const DeleteServicePromotionDialog = ({
    promotedService,
    active,
    onClose,
}: DeleteServicePromotionDialogProps) => {
    const deleteServicePromotion = useDeleteServicePromotion();

    const onDelete = () =>
        deleteServicePromotion.mutate(
            { promotedService },
            {
                onSuccess: () => closeAlert(promotedService.id),
                onSettled: onClose,
            }
        );

    const footer = {
        primary: (
            <Button variant="destructive" type="submit" size="medium" icon={IconName.Delete} onClick={onDelete}>
                {lt(TextKey.Delete)}
            </Button>
        ),
        secondary: (
            <Button variant="tertiary" type="button" size="medium" onClick={onClose}>
                {lt(TextKey.GoBack)}
            </Button>
        ),
    };
    return (
        <Dialog
            size="small"
            title={
                <LocalizedText
                    textKey={TextKey.PromotedServiceAssignmentDialogDelete}
                    substitutes={{ serviceName: promotedService.promotedServiceName }}
                />
            }
            footer={footer}
            active={active}
            onClose={onClose}
            loading={deleteServicePromotion.isPending}
        >
            {lt(TextKey.PromotedServiceAssignmentDialogDeleteText)}
        </Dialog>
    );
};
